import "./my-kit-boot";
import { createCookie } from "../helpers/read-write-cookies";
import { loadMyKitCookie } from "./load-my-kit-cookie";
import { updateMyKitTracker } from "./update-my-kit-tracker";
import { updateLocalStorageAlert } from "./update-local-storage-alert";
import { makeKey, getVariantForButton, variantRequiredButMissing, normaliseCookieValue } from "./my-kit-utils";

window.addEventListener("load", () => {
    let myKitCookie = loadMyKitCookie();
    let buttonListenerAdded = false;
    let variantListenerAdded = false;

    const addKeyToMyKit = (key) => {
        myKitCookie[key] = normaliseCookieValue(myKitCookie[key]);
        createCookie("myKit", JSON.stringify(myKitCookie), 365);
        updateMyKitTracker();
        updateLocalStorageAlert(); // broadcast only on mutation
    };

    const removeKeyFromMyKit = (key) => {
        delete myKitCookie[key];
        createCookie("myKit", JSON.stringify(myKitCookie), 365);
        updateMyKitTracker();
        updateLocalStorageAlert(); // broadcast only on mutation
    };

    const setButtonState = (btn) => {
        const id = btn.dataset.addToKit;
        const variant = getVariantForButton(btn);
        const key = makeKey(id, variant);
        const inKit = Object.hasOwn(myKitCookie, key);
        const needsVariant = variantRequiredButMissing(btn);

        btn.setAttribute("data-in-kit", inKit ? "true" : "false");
        btn.setAttribute("title", needsVariant ? "Select an option first" : (inKit ? "Remove from My Kit" : "Add to My Kit"));

        if (needsVariant) {
            btn.setAttribute("disabled", "");
        } else {
            btn.removeAttribute("disabled");
        }
    };

    const initializeMyKitClickListener = () => {
        window.addEventListener("click", (event) => {
            const target = event.target;
            if (!target.matches("button[data-add-to-kit]")) return;

            const btn = target;
            if (btn.disabled || variantRequiredButMissing(btn)) return;

            const id = btn.dataset.addToKit;
            const variant = getVariantForButton(btn);
            const key = makeKey(id, variant);
            const inKit = Object.hasOwn(myKitCookie, key);

            btn.setAttribute("data-in-kit", inKit ? "false" : "true");
            btn.setAttribute("title", inKit ? "Add to My Kit" : "Remove from My Kit");

            if (inKit) removeKeyFromMyKit(key);
            else addKeyToMyKit(key);

            myKitCookie = loadMyKitCookie();
            initializeMyKitButtons();
        });
    };

    const initializeVariantChangeListener = () => {
        if (variantListenerAdded) return;
        variantListenerAdded = true;

        document.addEventListener("change", (event) => {
            if (!event.target.matches("select[data-equipment-variant]")) return;
            const scope = event.target.closest("[data-add-to-kit-scope]") || event.target.closest("section");
            if (!scope) return;
            const btn = scope.querySelector("button[data-add-to-kit]");
            if (btn) setButtonState(btn);
        });
    };

    const initializeMyKitButtons = () => {
        const myKitButtons = document.querySelectorAll("button[data-add-to-kit]");
        if (!myKitButtons || myKitButtons.length === 0) return;

        if (!buttonListenerAdded) {
            initializeMyKitClickListener();
            buttonListenerAdded = true;
        }
        initializeVariantChangeListener();

        for (const btn of myKitButtons) {
            setButtonState(btn);
        }
    };

    const initializeMyKitTracker = () => {
        updateMyKitTracker();
    };

    initializeMyKitButtons();
    initializeMyKitTracker();

    // Ignore our own storage events
    window.addEventListener("storage", (event) => {
        if (event.key !== "myKitUpdated") return;
        let payload = null;
        try { payload = JSON.parse(event.newValue); } catch {}
        if (payload && payload.source && payload.source === window.__MY_KIT_TAB_ID__) return;

        myKitCookie = loadMyKitCookie();
        initializeMyKitButtons();
        initializeMyKitTracker();
    });
});
